'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-border">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link href="/" className="flex items-center gap-2">
            <AppLogo size={28} />
            <span className="font-semibold text-sm text-foreground">LabCall<span className="text-primary">Manager</span></span>
          </Link>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-2">Termini di Servizio</h1>
        <p className="text-sm text-muted-foreground mb-8">Ultimo aggiornamento: 1 gennaio 2025</p>
        <div className="space-y-6 text-muted-foreground text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">1. Accettazione dei Termini</h2>
            <p>Utilizzando LabCallManager, accetti integralmente i presenti Termini di Servizio. Se non accetti questi termini, non puoi utilizzare il servizio.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">2. Descrizione del Servizio</h2>
            <p>LabCallManager è una piattaforma SaaS per la gestione delle comunicazioni nei laboratori di analisi mediche. Il servizio include: gestione chiamate, gestione pazienti, tracciamento esami, analytics, automazione follow-up e portale paziente.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">3. Account e Registrazione</h2>
            <p>Per utilizzare il servizio è necessario creare un account. Sei responsabile di mantenere la riservatezza delle credenziali di accesso e di tutte le attività che avvengono sotto il tuo account.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">4. Piani e Pagamenti</h2>
            <p>Il servizio è disponibile in diversi piani a pagamento. I prezzi sono indicati nella pagina Prezzi. Il pagamento avviene anticipatamente su base mensile o annuale tramite Stripe. Non sono previsti rimborsi per periodi parziali.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">5. Uso Accettabile</h2>
            <p>Ti impegni a non utilizzare il servizio per: attività illegali, invio di spam, violazione della privacy di terzi, accesso non autorizzato a sistemi informatici, distribuzione di malware.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">6. Proprietà Intellettuale</h2>
            <p>LabCallManager e tutti i suoi contenuti sono di proprietà di LabCallManager S.r.l. È vietata la riproduzione, distribuzione o modifica senza autorizzazione scritta.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">7. Limitazione di Responsabilità</h2>
            <p>LabCallManager non è responsabile per danni indiretti, incidentali o consequenziali derivanti dall'uso del servizio. La responsabilità massima è limitata all'importo pagato negli ultimi 12 mesi.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">8. Disponibilità del Servizio</h2>
            <p>Ci impegniamo a garantire un uptime del 99.9% per i piani Enterprise. Per gli altri piani, il target è 99.5%. Manutenzioni programmate vengono comunicate con almeno 48 ore di anticipo.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">9. Risoluzione del Contratto</h2>
            <p>Puoi cancellare il tuo account in qualsiasi momento. In caso di violazione dei presenti termini, ci riserviamo il diritto di sospendere o terminare l'account senza preavviso.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">10. Legge Applicabile</h2>
            <p>I presenti termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di Milano.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-foreground mb-3">11. Contatti</h2>
            <p>Per qualsiasi domanda: legal@labcallmanager.com</p>
          </section>
        </div>
      </div>
    </div>
  );
}
